import { parseNumber, parseString } from './helpers'

export interface ProductInterface {
  id: string
  name: string
  code: string
  barcode: string
  quantity: number
}

export interface ProductAppendInterface {
  id: string
  title: string
  code: string
  barcode: string
  quantity_collected: number
  measure_unit: string
  type: string
}

export interface ProductResponseInterface {
  id: string
  name: string
  code: string
  barcode: string
}

export function parseProductModel(response: ProductResponseInterface): ProductInterface {
  return {
    id: parseString(response?.id),
    name: parseString(response?.name),
    code: parseString(response?.code),
    barcode: parseString(response?.barcode),
    quantity: 0,
  }
}

export function convertProductToAppendProduct(product: ProductInterface): ProductAppendInterface {
  return {
    id: parseString(product?.id),
    title: parseString(product?.name),
    code: parseString(product?.code),
    barcode: parseString(product?.barcode),
    quantity_collected: parseNumber(product?.quantity),
    measure_unit: 'vnt',
    type: 'SKU',
  }
}

export function convertProductsToAppendProducts(
  products: ProductInterface[]
): ProductAppendInterface[] {
  const appendProducts: ProductAppendInterface[] = []
  products.forEach((product) => appendProducts.push(convertProductToAppendProduct(product)))
  return appendProducts
}
